import { TutorialComponent } from './tutorial/tutorial.component'
import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { ViewTutorialComponent } from './tutorial/view-tutorial.component'

const routes: Routes = [
  {
    path: '',
    component: TutorialComponent,
  },
  {
    path: 'viewtutorial/:id',
    component: ViewTutorialComponent,
  },
  // {
  //   // ใช้สำหรับให้ scully ดึงไฟล์ json version เก่ามาทำ static ไฟล์
  //   path: 'viewtutorial/:title',
  //   component: ViewTutorialComponent,
  // },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TutorialRoutingModule {}
